import {
    GET_COMPANY_DASHBOARD_STATS,
    GET_COMPANY_DASHBOARD_STATS_SUCCESS,
    GET_COMPANY_DASHBOARD_STATS_FAIL,
} from "./actionTypes"

export const getCompanyDashboardStats = () => ({
    type: GET_COMPANY_DASHBOARD_STATS,
})

export const getCompanyDashboardStatsSuccess = stats => ({
    type: GET_COMPANY_DASHBOARD_STATS_SUCCESS,
    payload: stats,
})

export const getCompanyDashboardStatsFail = error => ({
    type: GET_COMPANY_DASHBOARD_STATS_FAIL,
    payload: error,
})
